import { useState } from "react";
import clsx from "clsx";
import { returnDateFromTenor } from "@/lib/businessRules/tenorRule";
import TicketDateInput from "./TicketDateInput";

// LQC-2975 - a date picker with a tenor box beside it. "5Y" + Enter/blur sets the date
// from tenorStart; the box then clears, so a stale tenor never sits beside a new date.
interface ITicketTenorDateInput {
  value: string; // yyyy-MM-dd
  onChange: (value: string) => void;
  testId: string;
  // yyyy-MM-dd the tenor counts from.
  tenorStart: string;
  holidayCalendars?: string[];
}

const TicketTenorDateInput = ({
  value,
  onChange,
  testId,
  tenorStart,
  holidayCalendars,
}: ITicketTenorDateInput) => {
  const [tenor, setTenor] = useState("");
  const [isInvalid, setIsInvalid] = useState(false);

  const applyTenor = () => {
    if (!tenor.trim()) {
      setIsInvalid(false);
      return;
    }
    const date = returnDateFromTenor(tenor, tenorStart);
    if (!date) {
      setIsInvalid(true);
      return;
    }
    onChange(date);
    setTenor("");
    setIsInvalid(false);
  };

  return (
    <div className="flex items-start gap-1">
      <input
        data-testid={`${testId}Tenor`}
        id={`${testId}Tenor`}
        type="text"
        placeholder="5Y"
        title="Tenor, e.g. 3M, 5Y, 1Y6M"
        value={tenor}
        onChange={(e) => setTenor(e.target.value)}
        onBlur={applyTenor}
        onKeyDown={(e) => {
          if (e.key === "Enter") applyTenor();
        }}
        className={clsx(
          "h-[28px] w-14 shrink-0 rounded-md border bg-transparent px-2 text-xs uppercase outline-none dark:bg-gray-800 dark:text-gray-200",
          isInvalid
            ? "border-red-600 bg-red-500/10 text-red-700 dark:border-red-500 dark:text-red-400"
            : "border-gray-300 dark:border-gray-600",
        )}
      />
      <TicketDateInput
        testId={testId}
        value={value}
        onChange={onChange}
        holidayCalendars={holidayCalendars}
      />
    </div>
  );
};

export default TicketTenorDateInput;
